export default __webpack_public_path__ + "static/media/Colonial Penn.2a9280ee.svg";